export const ScheduleInsuranceTabTrackingIds = {
  datePickerField: 'schedule-pulse:insurance-tab:date-picker-field',
  filterButton: 'schedule-pulse:insurance-tab:filter-button',
  resetButton: 'schedule-pulse:insurance-tab:reset-button',
  verificationAnalysisDatePickerField: 'schedule-pulse:insurance-tab:verification-analysis:date-picker-field',
  verificationAnalysisSwitchButton: 'schedule-pulse:insurance-tab:verification-analysis:switch-button',
  insuranceTabSwitchButton: 'schedule-pulse:insurance-tab:switch-button',
  datePickerAnalysisField: 'schedule-pulse:insurance-tab:verification-analysis:date-picker-field',
  datePickerNextButton: 'schedule-pulse:insurance-tab:date-picker-next-button',
  datePickerPreviousButton: 'schedule-pulse:insurance-tab:date-picker-previous-button',
  datePickerInputField: 'schedule-pulse:insurance-tab:date-picker-input-field',
  datePickerComponent: 'schedule-pulse:insurance-tab:date-picker-component',
  todayButton: 'schedule-pulse:insurance-tab:today-button',
};
